export const getLocaleFromDomain = (host?: string) => {
  const { defaultLocale, domains } = useRuntimeConfig().public.i18n
  if (!domains || !host) return defaultLocale

  const lastDomainSegment = host.substring(host.lastIndexOf('.'))
  const domain = domains[lastDomainSegment]
    || domains[Object.keys(domains).find((domainTld) => host.endsWith(domainTld)) || '']
  return domain?.defaultLocale || defaultLocale
}
